import React from 'react'

const BizPaymentHis = () => {
  return (
    <>
     <div>
            <h1 className='text-2xl ml-3  text-[#272C34] font-bold'>Payment history</h1>
            <div className='my-4 mx-2'>
            <div className='flex w-full'>

    <div class="md:flex w-full -mx-3 mb-6">
    <div class="md:w-[30%] w-full   px-3 mb-6 md:mb-0">
      <label class="block   tracking-wide text-gray-600 text-xs font-semibold mb-2" htmlFor="grid-first-name">
        From
      </label>
      <input class="appearance-none text-gray-400 block w-full rounded-2xl  h-[50px] bg-[#FBFEFF] text-gray-700 border border-gray-300 text-xs px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" type="date" />
     
    </div>
    <div class="md:w-[30%] w-full   px-3">
      <label class="block   tracking-wide text-gray-600 text-xs font-semibold mb-2" htmlFor="grid-last-name">
        To
      </label>
      <input class="appearance-none text-gray-400 block w-full rounded-2xl  h-[50px] bg-[#FBFEFF] text-gray-700 border border-gray-300 text-xs px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" type="date" />
    </div>
    <button className='flex mx-4 w-36 h-5 font-bold text-xs text-[#409BF5] mt-10 '><i class="fa-solid fa-download text-16 px-2"></i> <h4> Generate invoice</h4></button>
    </div>

                
            </div>
 
 
            </div>
               

               <div className='bg-[#ecf1f4]  py-4 rounded-full'>
               
               <table className='w-full'>
                       <tr className='flex   md:px-9 px-3'>
                           <td className=' px-1 w-[30px] md:w-[50px]'><h5 className='text-[12px] text-[#272C34] '>Sr. No</h5></td>
                           <td className=' px-1 w-[60px] md:w-[160px]'><h5 className='text-[12px] text-left text-[#272C34] '>Player</h5></td>
                           <td className='  px-1 w-[30px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '>No. of Bookings</h5></td>
                           <td className='px-1 w-[80px] md:w-[160px] '><h5 className='text-[12px] text-[#272C34] '>Court name</h5></td>
                           <td className=' px-1 w-[80px] md:w-[160px]'><h5 className='text-[12px] text-[#272C34] '>Booking time</h5></td>
                           <td className='px-1 w-[60px] md:w-[130px] '><h5 className='text-[12px] text-[#272C34] '>Amount</h5></td>

                       </tr>
                   </table>
               </div>


               <div>
                   <table className='w-full my-3'>
                   <tr className='flex  py-3 md:px-9 px-3'>
                           <td className=' px-1 w-[30px] md:w-[50px]'><h5 className='text-[12px] text-[#272C34] '>1</h5></td>
                           <td className=' px-2 w-[60px] md:w-[160px]'><h5 className='text-[12px] text-left text-[#272C34] '>John Doe</h5></td>
                           <td className='  px-1 w-[30px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '>3</h5></td>
                           <td className='px-1 w-[80px] md:w-[160px] '><h5 className='text-[12px] text-[#272C34] '>Paddel Buddy Court name</h5></td>
                           <td className=' px-2 w-[80px] md:w-[160px]'><h5 className='text-[12px] text-[#272C34] '>12:00 - 01:00 pm</h5></td>
                           <td className='px-1 w-[60px] md:w-[130px] '><h5 className='text-[12px] text-[#272C34] '>45.69$</h5></td>

                       </tr>

                       <tr className='flex  py-3 md:px-9 px-3'>
                           <td className=' px-1 w-[30px] md:w-[50px]'><h5 className='text-[12px] text-[#272C34] '>2</h5></td>
                           <td className=' px-2 w-[60px] md:w-[160px]'><h5 className='text-[12px] text-left text-[#272C34] '>John Doe</h5></td>
                           <td className='  px-1 w-[30px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '>1</h5></td>
                           <td className='px-1 w-[80px] md:w-[160px] '><h5 className='text-[12px] text-[#272C34] '>Paddel Buddy Court name</h5></td>
                           <td className=' px-2 w-[80px] md:w-[160px]'><h5 className='text-[12px] text-[#272C34] '>12:00 - 01:00 pm</h5></td>
                           <td className='px-1 w-[60px] md:w-[130px] '><h5 className='text-[12px] text-[#272C34] '>45.69$</h5></td>

                       </tr>

                       <tr className='flex  py-3 md:px-9 px-3'>
                           <td className=' px-1 w-[30px] md:w-[50px]'><h5 className='text-[12px] text-[#272C34] '>3</h5></td>
                           <td className=' px-2 w-[60px] md:w-[160px]'><h5 className='text-[12px] text-left text-[#272C34] '>John Doe</h5></td>
                           <td className='  px-1 w-[30px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '>4</h5></td>
                           <td className='px-1 w-[80px] md:w-[160px] '><h5 className='text-[12px] text-[#272C34] '>Paddel Buddy Court name</h5></td>
                           <td className=' px-2 w-[80px] md:w-[160px]'><h5 className='text-[12px] text-[#272C34] '>12:00 - 01:00 pm</h5></td>
                           <td className='px-1 w-[60px] md:w-[130px] '><h5 className='text-[12px] text-[#272C34] '>45.69$</h5></td>

                       </tr>

                       <tr className='flex  py-3 md:px-9 px-3'>
                           <td className=' px-1 w-[30px] md:w-[50px]'><h5 className='text-[12px] text-[#272C34] '>4</h5></td>
                           <td className=' px-2 w-[60px] md:w-[160px]'><h5 className='text-[12px] text-left text-[#272C34] '>John Doe</h5></td>
                           <td className='  px-1 w-[30px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '>2</h5></td>
                           <td className='px-1 w-[80px] md:w-[160px] '><h5 className='text-[12px] text-[#272C34] '>Paddel Buddy Court name</h5></td>
                           <td className=' px-2 w-[80px] md:w-[160px]'><h5 className='text-[12px] text-[#272C34] '>12:00 - 01:00 pm</h5></td>
                           <td className='px-1 w-[60px] md:w-[130px] '><h5 className='text-[12px] text-[#272C34] '>45.69$</h5></td>

                       </tr>

                       <tr className='flex  py-3 md:px-9 px-3'>
                           <td className=' px-1 w-[30px] md:w-[50px]'><h5 className='text-[12px] text-[#272C34] '>5</h5></td>
                           <td className=' px-2 w-[60px] md:w-[160px]'><h5 className='text-[12px] text-left text-[#272C34] '>John Doe</h5></td>
                           <td className='  px-1 w-[30px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '>2</h5></td>
                           <td className='px-1 w-[80px] md:w-[160px] '><h5 className='text-[12px] text-[#272C34] '>Paddel Buddy Court name</h5></td>
                           <td className=' px-2 w-[80px] md:w-[160px]'><h5 className='text-[12px] text-[#272C34] '>12:00 - 01:00 pm</h5></td>
                           <td className='px-1 w-[60px] md:w-[130px] '><h5 className='text-[12px] text-[#272C34] '>45.69$</h5></td>

                       </tr>

                       <tr className='flex  py-3 md:px-9 px-3'>
                           <td className=' px-1 w-[30px] md:w-[50px]'><h5 className='text-[12px] text-[#272C34] '>6</h5></td>
                           <td className=' px-2 w-[60px] md:w-[160px]'><h5 className='text-[12px] text-left text-[#272C34] '>John Doe</h5></td>
                           <td className='  px-1 w-[30px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '>3</h5></td>
                           <td className='px-1 w-[80px] md:w-[160px] '><h5 className='text-[12px] text-[#272C34] '>Paddel Buddy Court name</h5></td>
                           <td className=' px-2 w-[80px] md:w-[160px]'><h5 className='text-[12px] text-[#272C34] '>12:00 - 01:00 pm</h5></td>
                           <td className='px-1 w-[60px] md:w-[130px] '><h5 className='text-[12px] text-[#272C34] '>45.69$</h5></td>

                       </tr>

                       <tr className='flex  py-3 md:px-9 px-3'>
                           <td className=' px-1 w-[30px] md:w-[50px]'><h5 className='text-[12px] text-[#272C34] '>7</h5></td>
                           <td className=' px-2 w-[60px] md:w-[160px]'><h5 className='text-[12px] text-left text-[#272C34] '>John Doe</h5></td>
                           <td className='  px-1 w-[30px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '>1</h5></td>
                           <td className='px-1 w-[80px] md:w-[160px] '><h5 className='text-[12px] text-[#272C34] '>Paddel Buddy Court name</h5></td>
                           <td className=' px-2 w-[80px] md:w-[160px]'><h5 className='text-[12px] text-[#272C34] '>12:00 - 01:00 pm</h5></td>
                           <td className='px-1 w-[60px] md:w-[130px] '><h5 className='text-[12px] text-[#272C34] '>45.69$</h5></td>

                       </tr>

                       <tr className='flex  py-3 md:px-9 px-3'>
                           <td className=' px-1 w-[30px] md:w-[50px]'><h5 className='text-[12px] text-[#272C34] '>8</h5></td>
                           <td className=' px-2 w-[60px] md:w-[160px]'><h5 className='text-[12px] text-left text-[#272C34] '>John Doe</h5></td>
                           <td className='  px-1 w-[30px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '>2</h5></td>
                           <td className='px-1 w-[80px] md:w-[160px] '><h5 className='text-[12px] text-[#272C34] '>Paddel Buddy Court name</h5></td>
                           <td className=' px-2 w-[80px] md:w-[160px]'><h5 className='text-[12px] text-[#272C34] '>12:00 - 01:00 pm</h5></td>
                           <td className='px-1 w-[60px] md:w-[130px] '><h5 className='text-[12px] text-[#272C34] '>45.69$</h5></td>

                       </tr>

                       <tr className='flex  py-3 md:px-9 px-3'>
                           <td className=' px-1 w-[30px] md:w-[50px]'><h5 className='text-[12px] text-[#272C34] '>9</h5></td>
                           <td className=' px-2 w-[60px] md:w-[160px]'><h5 className='text-[12px] text-left text-[#272C34] '>John Doe</h5></td>
                           <td className='  px-1 w-[30px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '>3</h5></td>
                           <td className='px-1 w-[80px] md:w-[160px] '><h5 className='text-[12px] text-[#272C34] '>Paddel Buddy Court name</h5></td>
                           <td className=' px-2 w-[80px] md:w-[160px]'><h5 className='text-[12px] text-[#272C34] '>12:00 - 01:00 pm</h5></td>
                           <td className='px-1 w-[60px] md:w-[130px] '><h5 className='text-[12px] text-[#272C34] '>45.69$</h5></td>

                       </tr>

                       <tr className='flex  py-3 md:px-9 px-3'>
                           <td className=' px-1 w-[30px] md:w-[50px]'><h5 className='text-[12px] text-[#272C34] '>10</h5></td>
                           <td className=' px-2 w-[60px] md:w-[160px]'><h5 className='text-[12px] text-left text-[#272C34] '>John Doe</h5></td>
                           <td className='  px-1 w-[30px] md:w-[130px]'><h5 className='text-[12px] text-[#272C34] '>4</h5></td>
                           <td className='px-1 w-[80px] md:w-[160px] '><h5 className='text-[12px] text-[#272C34] '>Paddel Buddy Court name</h5></td>
                           <td className=' px-2 w-[80px] md:w-[160px]'><h5 className='text-[12px] text-[#272C34] '>12:00 - 01:00 pm</h5></td>
                           <td className='px-1 w-[60px] md:w-[130px] '><h5 className='text-[12px] text-[#272C34] '>45.69$</h5></td>

                       </tr>

                        

                   </table>
               </div>
                {/* pagination  */}

                <div className='flex justify-between mt-3 md:mt-9'>
               <nav aria-label="Page navigation example">
  <ul class="inline-flex items-center -space-x-px">
    <li>
      <a href="#" class="block py-2 px-3 ml-0 leading-tight text-gray-500 text-[12px]  rounded-l-lg  hover:bg-gray-100 hover:text-gray-700  ">
        <span class="sr-only">Previous</span>
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"></path></svg>
      </a>
    </li>
    <li>
      <a href="#" class="py-2 px-3 leading-tight   text-[12px]   hover:bg-gray-100 hover:text-gray-700  ">1</a>
    </li>
    <li>
      <a href="#" class="py-2 px-3 leading-tight text-gray-500 text-[12px]   hover:bg-gray-100 hover:text-gray-700  ">2</a>
    </li>
    <li>
      <a href="#" aria-current="page" class=" text-gray-500  py-2 px-3 leading-tight text-[12px]  hover:bg-blue-100 hover:text-blue-700  ">3</a>
    </li>
    <li>
      <a href="#" class="py-2 px-3 leading-tight text-gray-500 text-[12px]   hover:bg-gray-100 hover:text-gray-700  ">4</a>
    </li>
   
    <li>
      <a href="#" class="py-2 px-3 leading-tight text-gray-500 text-[12px]   hover:bg-gray-100 hover:text-gray-700  ">...</a>
    </li>
    <li>
      <a href="#" class="block py-2 px-3 leading-tight text-gray-500 text-[12px]  rounded-r-lg  hover:bg-gray-100 hover:text-gray-700  ">
        <span class="sr-only">Next</span>
        <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"></path></svg>
      </a>
    </li>
  </ul>
</nav>
<h3 className='text-gray-500 text-[12px] mt-3'>1 of 729</h3>
</div>







            </div>
     </>
  )
}

export default BizPaymentHis